import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Helmet } from 'react-helmet-async';
import { PredictionsProvider } from './context/PredictionsContext';
import Desktop from './Desktop';
import Mobile from './Mobile';
import HeroBanner from './components/HeroBanner';

const Prediction = () => {
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });
  
  return (
    <PredictionsProvider>
      <Helmet>
        <script src="https://s3.tradingview.com/tv.js" type="text/javascript" id="tradingViewWidget" />
      </Helmet>
      <div className="lb-page relative min-h-screen w-full px-3 py-8 text-white sm:px-6 sm:py-10">
        <div className="relative mx-auto w-full max-w-screen-xl">
          <HeroBanner />
          <div className="lb-shell mt-6">
            {isDesktop ? <Desktop /> : <Mobile />}
          </div>
        </div>
      </div>
    </PredictionsProvider>
  );
};

export default Prediction;
